import React, { Suspense, useState } from 'react';
import ProgressBar from '../../Sections/ProgressBar/ProgressBar';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import imgSrc from './../../Assets/img/misc/commingSoonCalculator.png';
import './mobilecalculator/mobileCalculator.css';
import './../../Sections/CalculatorsSection/CalculatorsSection.css';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles({
  grid: {
    marginTop: '16px',
    marginBottom: '16px',
    paddingLeft: '8px',
    paddingRight: '8px',
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
  },
  para: {
    textAlign: 'left',
    marginTop: '8px',
    paddingLeft: '8px',
  },
});
function RenderDesktopCalculator(props) {
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);
  const calculator = props.calculator;
  const Component = props.calculator.component;
  const { t } = useTranslation();
  const modalHandler = () => {
    setShowModal((st) => !st);
  };
  return (
    <Grid xs={12} md={4} lg={4} className={classes.grid}>
      <div
        className="calculator-service"
        style={{ position: 'relative' }}
        id={calculator.name}
      >
        <h5 style={{ textAlign: 'center' }}>{calculator.name}</h5>
        <div className="calculator_para_wrapper">
          <p className="calc-box-service" title={calculator.content}>
            {calculator.content}
          </p>
        </div>
        <Button
          variant="contained"
          className={classes.button}
          onClick={modalHandler}
        >
          <i className="bx bxs-calculator" style={{ fontSize: '1.4rem' }}></i>
        </Button>

        <Modal onRequestClose={modalHandler} isOpen={showModal}>
          <Suspense fallback={<ProgressBar />}>
            <CloseIcon onClick={modalHandler} />
            {Component ? (
              <Component />
            ) : (
              <div className="calculator-not-available calculator__not-available">
                <img src={imgSrc} alt="Calculator not enabled" />
                <p className={classes.para}>{t('services-main-render-para')}</p>
              </div>
            )}
          </Suspense>
        </Modal>
      </div>
    </Grid>
  );
}

export default RenderDesktopCalculator;
